import axiosClient from "api/apiClient";

export const APIPostReport = (data: object) => {
    return axiosClient.post(`reports/show`, data);
  };

export const APIPostExternalReports = (data: object) => {

    return axiosClient.post(`${process.env.REACT_APP_API}/external/report`, data);
}